import { FaCamera } from "react-icons/fa";
import { useRef, useState } from "react";

const ProfilePicture = ({ image, onUpload }) => {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(
    image ||
      "https://res.cloudinary.com/dwuhamihv/image/upload/v1761652467/myshop/profile/og0jxjvu0zjdpkznhadz.png"
  );
  console.log("profimg", `${image}`);
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // آپلود فایل
    const uploadedUrl = await onUpload(file);

    // فقط آدرس سرور
    setPreview(uploadedUrl);
  };

  return (
    <div className="d-flex flex-column align-items-center mt-3">
      <div className="position-relative">
        <img
          src={
            image
              ? `${image}`
              : `https://res.cloudinary.com/dwuhamihv/image/upload/v1761652467/myshop/profile/og0jxjvu0zjdpkznhadz.png`
          }
          alt="Profile"
          className="rounded-circle border border-3 border-primary"
          style={{ width: "150px", height: "150px", objectFit: "cover" }}
          onError={(e) => {
            e.target.onerror = null; // جلوگیری از لوپ بی‌نهایت
            e.target.src = "/assets/images/default-avatar.png";
          }}
        />
        <button
          className="btn btn-sm btn-primary rounded-circle position-absolute p-2 pt-1 bottom-0 end-0"
          onClick={() => fileInputRef.current.click()}
        >
          <FaCamera size={16} />
        </button>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept="image/*"
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
};

export default ProfilePicture;
